module.exports = __webpack_public_path__ + "img/camioneta.ecd0a125.jpg";